import {AuthModel} from './_models'
import {showToast, TOAST_FAILURE, TOAST_WARNING} from "../../../utils/toast/Toast";

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const getErrorMessage = (data: any): string | null => {
  if (!data) return null;
  if (typeof data === 'string' && data.trim()) return data;
  if (typeof data === 'object' && data.message && typeof data.message === 'string') {
    return data.message;
  }
  return null;
};

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.accessToken) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(function (response: any) {
    return response;
  }, function (error: any) {
    // Log errors for debugging
    console.error('API Error:', error);

    const suppressToast = error.config && error.config.suppressToast;

    // Handle authentication errors (token expired) - skip for login requests
    if (error.response && error.response.status === 401 && !suppressToast) {
      removeAuth();
      window.location.href = '/auth';
      return Promise.reject(error);
    }
    if (error.response === undefined) {
      if (!suppressToast) {
        showToast("Not able to reach the server, Try again.", TOAST_FAILURE, {
          toastId: "server-unreachable",
        })
      }
    } else if (error.response.status === 403) {
      if (!suppressToast) {
        const message = getErrorMessage(error.response.data);
        if (message) {
          showToast(message, TOAST_WARNING);
        }
      }
    } else if (error.response.status === 406) {
      if (!suppressToast) {
        showToast("You don't have permission to do this operation, Please Contact your Administrator", TOAST_WARNING);
      }
    } else if (error.response.status !== 200) {
      if (!suppressToast) {
        const message = getErrorMessage(error.response.data);
        if (message) {
          showToast(message, TOAST_FAILURE);
        }
      }
    }

    return Promise.reject(error);
  });
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
